import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const STAT_LIST_PATHNAME = '/stats';

export const StatListLoadable = loadable(async () => import('./objective-stats-list/challenge-stat-list.view'), {
  fallback: <FullPageLoading />,
});
